import React from 'react'
import Link from '../components/base/link'
import DocTorso from '../media/docTorso.png'
import Hero from 'baseComponents/hero'
import Steps from '../components/hybrid/steps'
import Benefits from '../components/hybrid/benefits'
import Button from 'material-ui/Button';
import { fonts, colors, applicationStyles } from '../themes'
import { navigateTo } from "gatsby-link"
import Doctors6 from 'media/doctors6.png'
import DoximityLogin from 'components/base/doximityLogin'
import Cookies from 'js-cookie'
import Loading from 'components/base/loading'
import calendarIphone from 'media/calendarIphone.png'
import MainHelmet from 'components/base/mainHelmet'
import generateJobsSchema from 'lib/jobs'
import withAuth, { publicAuth } from 'components/hocs/withAuth'

const styles = {
  second: {
    display: 'flex',
    flex: 1, 
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.white,
    padding: 45,
  },
  mock: {
    width: '80%',
    maxWidth: 200,
  },
  button: {
    margin: '20px',
    cursor: 'pointer',
    color: colors.darkBlue,
    backgroundColor: colors.white,
    padding: 20,
    borderRadius: 10,
    fontSize: '1.5em',
  }
}

class IndexPage extends React.Component {
  constructor() {
    super()
    this.state = {
      loading: false,
      referralSlug: null,
    }
    this.onClick = this.onClick.bind(this)
  }

  componentDidMount() {
    this.setState({ referralSlug: Cookies.get('referralSlug')})
  }

  onClick() {
    GA('send', {
      hitType: 'event',
      eventCategory: 'Auth',
      eventAction: `Signup`,
      eventLabel: 'Doximity',
    })
    this.setState({ loading: true })
  }
  render() {
    if (this.props.user) {
      // They are logged in, redirect to app
      navigateTo('/app/opportunities')
    }
    if (this.state.loading) {
      return <Loading />
    }
    return (
      <div css={{ display: 'flex', flex: 1, flexDirection: 'column'}}>
        <MainHelmet script={generateJobsSchema()}/>
        <Hero backgroundColor={colors.darkBlue} >
          <img src={Doctors6} css={{ maxHeight: 170, maxWidth: '80%' }}/>
          <h1 css={{ color: colors.white }}>Moonlighting Simplified.</h1>
          <div css={{ width: '80%', maxWidth: 800, borderBottom: `3px solid ${colors.green}`}}>
          </div>
          <p css={{ color: colors.white }}>Sign up for the beta!</p>
          <DoximityLogin
            onClick={this.onClick}
            imageType="verify"
            referralSlug={this.state.referralSlug}
          />
        </Hero>
        <div css={styles.second}>
          <h2 css={{ color: colors.darkBlue, textAlign: 'center' }}>Work on your own time with local hospitals</h2>
          <Benefits />
        </div>
        <Hero backgroundColor={colors.darkBlue}>
          <h1 css={{ color: colors.white, marginBottom: '80px' }}>Here's how we work</h1>
          <Steps />
        </Hero>
        <div css={styles.second}>
          <h2 css={{ color: colors.darkBlue, textAlign: 'center' }}>Simple is Better.</h2>
          <img src={calendarIphone} css={styles.mock}/>
        </div>
        <div css={{...styles.second, backgroundColor: colors.darkBlue }}>
          <div css={styles.button} onClick={() => navigateTo('/beta')}>Join the Beta!</div>
        </div>
      </div>
    )
  }
}

export default withAuth(IndexPage, publicAuth)


// WEBPACK FOOTER //
// ./src/pages/index.js